import { render, staticRenderFns } from "./message-confirm-modal.vue?vue&type=template&id=9a8ed5e0&scoped=true&"
import script from "./message-confirm-modal.vue?vue&type=script&lang=js&"
export * from "./message-confirm-modal.vue?vue&type=script&lang=js&"
import style0 from "./message-confirm-modal.vue?vue&type=style&index=0&id=9a8ed5e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8ed5e0",
  null
  
)

export default component.exports